import { useSkuPriceTiering } from "../../hooks/useSkuPriceTiering";

import { MECHANIC_SKU_PRICE_TIERING_TYPE } from "../../constants/mechanic";

import { PriceDiscount } from "../ui";

function SkuPriceTiering(props) {
  const {
    skuId,
    suggestedSellingPrice,
    skuInitNextTier,
    mechanicSkuPriceTieringType,
  } = props;

  const {
    isSkuTotalPriceVisible,
    skuTotalPrice,
    skuTotalPriceAfterDiscount,
    nextPriceTier,
  } = useSkuPriceTiering(skuId, skuInitNextTier);

  if (
    (mechanicSkuPriceTieringType !==
      MECHANIC_SKU_PRICE_TIERING_TYPE.EXACT_QUANTITY &&
      mechanicSkuPriceTieringType !== MECHANIC_SKU_PRICE_TIERING_TYPE.RANGE) ||
    (!isSkuTotalPriceVisible && !nextPriceTier)
  ) {
    return null;
  }

  let nextPriceTierView;
  if (nextPriceTier) {
    if (
      mechanicSkuPriceTieringType ===
      MECHANIC_SKU_PRICE_TIERING_TYPE.EXACT_QUANTITY
    ) {
      nextPriceTierView = (
        <span>
          زود الكمية حتي{" "}
          <span className="font-extrabold text-blue-1">
            {nextPriceTier.quantity}
          </span>{" "}
          ليصبح سعر القطعة
        </span>
      );
    } else if (
      mechanicSkuPriceTieringType === MECHANIC_SKU_PRICE_TIERING_TYPE.RANGE &&
      nextPriceTier.maxQuantity
    ) {
      nextPriceTierView = (
        <span>
          ضيف كمية ما بين{" "}
          <span className="font-extrabold text-blue-1">
            {nextPriceTier.minQuantity} - {nextPriceTier.maxQuantity}
          </span>{" "}
          ليصبح سعر القطعة
        </span>
      );
    } else if (
      mechanicSkuPriceTieringType === MECHANIC_SKU_PRICE_TIERING_TYPE.RANGE &&
      !nextPriceTier.maxQuantity
    ) {
      nextPriceTierView = (
        <span>
          ضيف كمية تساوي{" "}
          <span className="font-extrabold text-blue-1">
            {nextPriceTier.minQuantity}
          </span>{" "}
          فيما فوق ليصبح سعر القطعة
        </span>
      );
    }
  }

  return (
    <div className="px-4 py-1 border border-slate-400 rounded-md bg-slate-100 text-center drop-shadow-sm">
      {isSkuTotalPriceVisible && (
        <div className="flex flex-wrap justify-between">
          <p className="flex-grow">الإجمالي الحالي: </p>
          <PriceDiscount
            oldPrice={skuTotalPrice}
            newPrice={skuTotalPriceAfterDiscount}
            className="flex-grow"
          />
        </div>
      )}
      {nextPriceTier && (
        <div className="flex flex-wrap justify-between gap-2">
          <p className="flex-grow">{nextPriceTierView}</p>
          <PriceDiscount
            oldPrice={suggestedSellingPrice}
            newPrice={nextPriceTier.price}
            className="flex-grow"
          />
        </div>
      )}
    </div>
  );
}

export default SkuPriceTiering;
